import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf'
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Unauthorized from "../general/Unauthorized";
import SelectorCiudad from "../custom/SelectorCiudad";
import SelectorPais from "../custom/SelectorPais";
import SelectorTipoDocumento from "../custom/SelectorTipoDocumento";
import SelectorZona from "../custom/SelectorZona";
import CampoNit from "../custom/CampoNit";

function CrearEmpresa() {

    // Estados para datos de la empresa
    const [nombreEmpresa, setNombreEmpresa] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [digitoVerificacion, setDigitoVerificacion] = useState('');
    const [descripcion, setDescripcion] = useState('');
    
    // Estados para domicilio
    const [direccion, setDireccion] = useState('');
    const [ciudadResidencia, setCiudadResidencia] = useState(null);
    const [paisResidencia, setPaisResidencia] = useState('');
    const [zona, setZona] = useState('');
    const [telefono, setTelefono] = useState('');
    const [celular, setCelular] = useState('');
    const [email, setEmail] = useState('');

    // Estados de control
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [errorlist, setErrorlist] = useState({});

    // Función para manejar el cambio del NIT y DV
    const handleNitChange = (nit, dv) => {
        setNumeroDocumento(nit);
        setDigitoVerificacion(dv);
    };

    let history = useHistory();
    let userdata = [];

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));

        // 🔒 VALIDACIÓN DE PERMISOS - Patrón híbrido (nuevo + legacy)
        let tienePermiso = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'crearPacientes');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('crearPacientes')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // ✅ Cargar datos del cliente - Sin config manual (interceptor maneja el token)
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
                setLoggedIn(true);
            });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Validaciones del lado del cliente - Solo campos visibles en el formulario
        const errores = {};
        
        if (!nombreEmpresa.trim()) {
            errores.primer_nombre = ['El nombre de la empresa es obligatorio'];
        }
        
        if (!tipoDocumento) {
            errores.tipo_documento = ['El tipo de documento es obligatorio'];
        }
        
        if (!numeroDocumento.trim()) {
            errores.numero_documento = ['El número de documento es obligatorio'];
        }
        
        // Validación opcional del email si se proporciona
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errores.email = ['El formato del email no es válido'];
        }
        
        // Si hay errores, mostrarlos y no enviar
        if (Object.keys(errores).length > 0) {
            setErrorlist(errores);
            return;
        }
        
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // Datos para crear empresa - Solo campos del formulario (sin client_id)
        const data = {
            primer_nombre: nombreEmpresa,
            tipo_documento: tipoDocumento,
            numero_documento: numeroDocumento,
            dv: digitoVerificacion ? String(digitoVerificacion) : null, // Convertir DV a string
            nombre_ocupacion: descripcion,
            direccion: direccion,
            ciudad: ciudadResidencia,
            pais_residencia: paisResidencia,
            zona: zona,
            telefono: telefono,
            celular: celular,
            email: email
        };

        // ✅ Crear empresa - Sin config manual (interceptor maneja el token)
        axios.post('/empresa', data)
            .then(response => {
                setLoading(false);
                localStorage.setItem('msgtoast', 'Empresa creada exitosamente');
                history.push('/empresas'); // ✅ Redirigir a ListarEmpresas
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    console.error('Error creando empresa:', error);
                }
            });
    };

    useEffect(() => {
        if (Object.keys(errorlist).length > 0) {
            const timer = setTimeout(() => {
                setErrorlist({});
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [errorlist]);

    // Protección de ruta estándar
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn) {
        return <div>Cargando...</div>;
    }

    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="patients" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/menu-pacientes">Pacientes</Link></li>
                                    <li className="breadcrumb-item">Crear Empresa</li>
                                </ol>

                                {Object.keys(errorlist).length > 0 && (
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        <ul className="mb-0">
                                            {Object.values(errorlist).map((messages, index) => (
                                                <li key={index}>{Array.isArray(messages) ? messages[0] : messages}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Crear Empresa</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <form onSubmit={handleSubmit} autoComplete="off" className="crear-empresa-form">
                            <div className="row">
                                <div className="col-12">

                                    {/* Datos de la Empresa */}
                                    <div className="card report-fin-card mb-3">
                                        <div className="card-header">
                                            <h4 className="card-title mb-0">
                                                <i className="fas fa-building mr-2 text-secondary"></i>
                                                Datos de la Empresa
                                            </h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="nombreEmpresa">Nombre de la Empresa *</label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        id="nombreEmpresa"
                                                        value={nombreEmpresa}
                                                        onChange={(e) => setNombreEmpresa(e.target.value)}
                                                        required
                                                    />
                                                    {errorlist.primer_nombre && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.primer_nombre[0]}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="descripcion">Descripción</label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        id="descripcion"
                                                        value={descripcion}
                                                        onChange={(e) => setDescripcion(e.target.value)}
                                                        placeholder="Actividad económica, giro del negocio, etc."
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-row align-items-start crear-empresa-doc-row">
                                                <div className="col-md-3 crear-empresa-tipo-doc">
                                                    <SelectorTipoDocumento
                                                        value={tipoDocumento}
                                                        onChange={setTipoDocumento}
                                                        error={errorlist.tipo_documento?.[0]}
                                                        required={true}
                                                    />
                                                </div>
                                                <div className="col-md-9 crear-empresa-nit-wrap">
                                                    <CampoNit
                                                        valor={numeroDocumento}
                                                        digitoVerificacion={digitoVerificacion}
                                                        onChange={handleNitChange}
                                                        anchoValor="78"
                                                        anchoDigito="22"
                                                        inputClassName="form-control form-control-sm"
                                                    />
                                                    {errorlist.numero_documento && (
                                                        <div className="invalid-feedback visible d-block">
                                                            {errorlist.numero_documento[0]}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="form-row">
                                                <div className="form-group col-md-12 mb-0">
                                                    <label htmlFor="email">Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control form-control-sm"
                                                        id="email"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                    {errorlist.email && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.email[0]}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Domicilio de la Empresa */}
                                    <div className="card report-fin-card mb-3">
                                        <div className="card-header">
                                            <h4 className="card-title mb-0">
                                                <i className="fas fa-map-marker-alt mr-2 text-secondary"></i>
                                                Domicilio de la Empresa
                                            </h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="form-row">
                                                <div className="form-group col-md-12 mb-2">
                                                    <label htmlFor="direccion">Dirección</label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        id="direccion"
                                                        value={direccion}
                                                        onChange={(e) => setDireccion(e.target.value)}
                                                    />
                                                    {errorlist.direccion && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.direccion[0]}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="ciudadResidencia">Ciudad</label>
                                                    <SelectorCiudad
                                                        value={ciudadResidencia}
                                                        onChange={setCiudadResidencia}
                                                    />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="paisResidencia">País</label>
                                                    <SelectorPais
                                                        value={paisResidencia}
                                                        onChange={setPaisResidencia}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-row">
                                                <div className="form-group col-md-4">
                                                    <SelectorZona
                                                        value={zona}
                                                        onChange={setZona}
                                                        error={errorlist.zona?.[0]}
                                                    />
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label htmlFor="telefono">Teléfono</label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        id="telefono"
                                                        value={telefono}
                                                        onChange={(e) => setTelefono(e.target.value)}
                                                    />
                                                    {errorlist.telefono && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.telefono[0]}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label htmlFor="celular">Celular</label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        id="celular"
                                                        value={celular}
                                                        onChange={(e) => setCelular(e.target.value)}
                                                    />
                                                    {errorlist.celular && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.celular[0]}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Botones */}
                                    <div className="form-row mb-4">
                                        <div className="col-12 d-flex flex-wrap align-items-center">
                                            <button type="submit" className="btn btn-secondary mb-2 mb-sm-0" disabled={loading}>
                                                <i className="fas fa-save mr-2"></i>
                                                Guardar empresa
                                                {loading && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>}
                                            </button>
                                            <Link to="/menu-pacientes" className="btn btn-outline-secondary ml-sm-2 mb-2 mb-sm-0">
                                                <i className="fas fa-times mr-2"></i>
                                                Cancelar
                                            </Link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
                </section>
            </div>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default CrearEmpresa;